"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importDefault(require("react"));
const react_imask_1 = require("react-imask");
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const decimalSeparator = (1.1)
    .toLocaleString(navigator.language)
    .substring(1, 2);
const thousandsSeparator = (1111111)
    .toLocaleString(navigator.language)
    .substring(1, 2);
const NumberInput = ({ onChange, onBlur = () => null, onClick = () => null, value, placeholder, className, precision = 2, formattedResult = false, dataCy, label, labelClass, htmlFor, showBorderOnHover, inputClass, disabled, readonly, allowNegative = true, max = 999999999999999, withRightIcon, padFractionalZeros = false, customNextElement, ableToInputZero = false, onComplete = () => null, customPrevElement }) => {
    const inputCN = (0, classnames_template_literals_1.default)(`styled-input ${showBorderOnHover && 'show-border-on-hover'} ${inputClass && inputClass} ${(disabled || readonly) &&
        'border-gray cursor-not-allowed border border-solid bg-n-100 text-n-800'}`);
    const onAcceptHandler = (value) => {
        if (!disabled && !readonly && onChange) {
            onChange(value);
        }
    };
    const getValue = () => {
        if (ableToInputZero)
            return value?.toString();
        if (value)
            return value.toString();
        return '';
    };
    return (react_1.default.createElement("div", { className: `container-input ${className ? className : ''}` },
        label && (react_1.default.createElement("label", { className: `${labelClass ? labelClass : 'styled-label'}`, htmlFor: htmlFor }, (0, HelperUtils_1.getObjectiveLocale)(label))),
        react_1.default.createElement("div", { className: "relative" },
            customPrevElement && customPrevElement,
            react_1.default.createElement(react_imask_1.IMaskInput, { unmask: !formattedResult, mask: Number, className: inputCN, value: getValue(), 
                // @ts-ignore
                onAccept: onAcceptHandler, onComplete: onComplete, onBlur: onBlur, radix: decimalSeparator, thousandsSeparator: thousandsSeparator, placeholder: placeholder ? (0, HelperUtils_1.getObjectiveLocale)(placeholder) : '', scale: precision, "data-cy": dataCy, name: htmlFor, id: htmlFor, disabled: disabled, signed: allowNegative, max: max, padFractionalZeros: padFractionalZeros, onScroll: (e) => e.stopPropagation(), onClick: onClick }),
            disabled && withRightIcon && (react_1.default.createElement(TooltipContainer_1.default, { show: !(0, isEmpty_1.default)(withRightIcon?.tooltipText), position: "top", text: withRightIcon?.tooltipText, useMaxWidth: false, classContainer: "absolute right-[8px] top-1/2 -translate-y-2/4" },
                react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: "icon-info" }))),
            customNextElement && customNextElement)));
};
exports.default = NumberInput;
